import { ARTICLE } from "./article";
import { AUTH } from "./authentication";
import { CIRCLE } from "./circle";
import { COMMENTS } from "./comments";
import { CONNECTIONS } from "./connections";
import { GLOBAL } from "./global";
import { IMAGES } from "./images";
import { INFO } from "./info";
import { ME } from "./me";
import { METADATA_POSTS } from "./metadataPosts";
import { NEWSFEED } from "./newsfeed";
import { ONBOARDING } from "./onboarding";
import { POLLS } from "./polls";
import { POSTAUDIO } from "./postAudio";
import { POSTGIF } from "./postGIF";
import { POST_LIKES } from "./postLikes";
import { POST_REACTIONS } from "./postReactions";
import { POSTS } from "./posts";
import { POSTVIDEO } from "./postVideo";
import { SAVED_ITEMS } from "./savedItems";

export const API_CALLS = {
  ARTICLE,
  ME,
  POST_REACTIONS,
  POSTS,
  POST_LIKES,
  POLLS,
  AUTH,
  COMMENTS,
  CONNECTIONS,
  IMAGES,
  INFO,
  NEWSFEED,
  ONBOARDING,
  SAVED_ITEMS,
  CIRCLE,
  METADATA_POSTS,
  POSTAUDIO,
  POSTVIDEO,
  POSTGIF,
  GLOBAL,
};
